var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('v-header'),_vm._v(" "),_c('v-sidebar'),_vm._v(" "),_c('div',{class:_vm.isCollapse ? 'el-tagnavigation-no' : 'el-tagnavigation'},[_c('v-tags'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
return [_c('transition',{attrs:{"name":"move","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.tagsList}},[_c(Component,{tag:"component"})],1)],1)]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a92c0a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = null
// module chunks = 